import { getRenderStrategy } from "../../core/access-control";
import type { ResolvedRenderStrategy } from "../../core/access-control";

/**
 * Per-surface render strategy for the current tenant, as ready-made booleans.
 * The underlying value is memoized, so this is stable across renders.
 */
export const useRenderStrategy = (): ResolvedRenderStrategy =>
  getRenderStrategy();
